import { DataType } from "@cloudpivot/form/typings";
import { inputControlOptions } from ".";
/**
 * 选人控件可选类型
 */
export var StaffSelectorSelectType;
(function (StaffSelectorSelectType) {
    /**
     * 所有
     */
    StaffSelectorSelectType["All"] = "all";
    /**
     * 用户
     */
    StaffSelectorSelectType["User"] = "user";
    /**
     * 部门
     */
    StaffSelectorSelectType["Org"] = "org";
})(StaffSelectorSelectType || (StaffSelectorSelectType = {}));
/**
 * 选人控件值类型
 */
export var StaffSelectorValueType;
(function (StaffSelectorValueType) {
    /**
     * 空，取设置的固定值
     */
    StaffSelectorValueType["None"] = "";
    /**
     * 创建人，前发起人
     */
    StaffSelectorValueType["Originator"] = "originator";
    /**
     * 创建人部门，前发起人部门
     */
    StaffSelectorValueType["OriginatorDept"] = "originatorDept";
    /**
     * 引用控件值
     */
    StaffSelectorValueType["Ref"] = "ref";
})(StaffSelectorValueType || (StaffSelectorValueType = {}));
export var DisplayType;
(function (DisplayType) {
    DisplayType["Text"] = "text";
    DisplayType["Tag"] = "tag";
})(DisplayType || (DisplayType = {}));
/**
 * 选人控件
 */
export const staffSelectorOptions = {
    $id: "staffSelectorOptions",
    type: DataType.Object,
    $ref: inputControlOptions.$id,
    properties: {
        deptVisible: {
            type: DataType.String,
            title: "可选类型",
            default: StaffSelectorSelectType.All,
        },
        roles: {
            type: DataType.String,
            title: "角色范围",
            default: "",
        },
        mappings: {
            type: DataType.String,
            title: "映射关系",
            default: "",
        },
        displayType: {
            type: DataType.String,
            title: "displayType",
            default: DisplayType.Tag,
        },
        multi: {
            type: DataType.Boolean,
            title: "是否多选",
            default: false,
        },
        recursive: {
            type: DataType.Boolean,
            title: "是否递归展示",
            default: false,
        },
        defaultValue: {
            type: DataType.Array,
            title: "默认值",
            default: [],
        },
        defaultValueType: {
            type: DataType.String,
            title: "默认值类型",
            default: StaffSelectorValueType.None,
        },
    },
};
/**
 * 上传限制
 */
export var UploadLimitType;
(function (UploadLimitType) {
    UploadLimitType["1M"] = "1M";
    UploadLimitType["5M"] = "5M";
    UploadLimitType["10M"] = "10M";
    UploadLimitType["20M"] = "20M";
    UploadLimitType["50M"] = "50M";
    UploadLimitType["100M"] = "100M";
    UploadLimitType["200M"] = "200M";
    // '512M' = '512M',
    // '1G' = '1G'
})(UploadLimitType || (UploadLimitType = {}));
/**
 * 子表显示模式
 */
export var SheetDisplayMode;
(function (SheetDisplayMode) {
    /**
     * 瀑布
     */
    SheetDisplayMode["Waterfall"] = "waterfall";
    /**
     * 分页
     */
    SheetDisplayMode["Page"] = "page";
    /**
     * 二维
     */
    SheetDisplayMode["Table"] = "table";
})(SheetDisplayMode || (SheetDisplayMode = {}));
export const uploadOptions = {
    $id: "uploadOptions",
    type: DataType.Object,
    $ref: inputControlOptions.$id,
    properties: {
        displayFormula: {
            type: DataType.String,
            title: "显示条件",
            default: "",
        },
        requiredFormula: {
            type: DataType.String,
            title: "是否必填",
            default: "",
        },
        limit: {
            type: DataType.String,
            title: "文件大小限制",
            default: "5M",
        },
        batch: {
            type: DataType.Boolean,
            title: "批量下载",
            default: true,
        },
    },
};
export const baseUploadOptions = {
    $id: "baseUploadOptions",
    type: DataType.Object,
    $ref: uploadOptions.$id,
    properties: {
        onUpload: {
            type: DataType.String,
            title: "上传事件",
            default: "",
        },
        onDelete: {
            type: DataType.String,
            title: "删除事件",
            default: "",
        },
    },
};
